import Vuex from 'vuex';
import Vue from 'vue';
Vue.use(Vuex);
import { AxiosErrorHandler, isAxiosError } from './util/AxiosErrorHandler';
import SBAPI from "@/util/SBAPI";
import { LoginStatus } from './generated/api';

interface RootState {
    user: LoginStatus | null;
    error: string;
    en: boolean;
}

export default new Vuex.Store<RootState>({
    state: {
        user: null,
        error: "",
        en: false,
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        getUserAPI: async (state) => {
            let res = await SBAPI.LoginController.loginStatusUsingGET().catch(AxiosErrorHandler);
            if (isAxiosError(res)) {
                if (res.status == 999) {
                    state.state.error = "通信エラーが発生しました。通信環境の良いところで再度アクセスしてください。";
                } else {
                    state.state.error = "サーバーエラーが発生しました。しばらく時間をおいてから再度アクセスしてください。";
                }
            } else {
                if (res.data.userId) {
                    // ログイン中
                    state.state.user = res.data;
                } else {
                    // ログアウト中
                    state.state.user = null;
                }
            }
        },
        changeLanguageAPI: async (state) => {
            state.state.en = !state.state.en;
        }
    },
});
